import {useState} from "react";


const ComparisonReportConfigurator = (props) => {

    const detailCards = props.showDetailCards
    const graphicalCharts = props.showGraphicalCharts
    const dataTables = props.showDataTables
    const setShowDetailCards = props.setShowDetailCards
    const setShowGraphicalCharts = props.setShowGraphicalCharts
    const setShowDataTables = props.setShowDataTables

    const [reportName, setReportName] = useState("");
    const [coverPages, setCoverPages] = useState(true);
    const [introduction, setIntroduction] = useState(true);
    const [debrief, setDebrief] = useState(true);
    const [backPage, setBackPage] = useState(true);

    const handleSlider = (ev) => {
        if (!ev) return;
        let id = ev.currentTarget.id
        switch (id) {
            case '1': setCoverPages(!coverPages); break;
            case '2': setIntroduction(!introduction); break;
            case '3': setDebrief(!debrief); break;
            case '4': setShowDetailCards(!detailCards); break;
            case '5': setShowGraphicalCharts(!graphicalCharts); break;
            case '6': setShowDataTables(!dataTables); break;
            case '7': setBackPage(!backPage); break;  // add this for backPage
            default: break;
        }
    }

    const handleSubmit = () => {
        let body = {
            "name": reportName,
            "cover_pages": coverPages,
            "introduction": introduction,
            "debrief": debrief,
            "pillars": false,
            "next_steps": false,
            "back_page": backPage
        }
        props.saveConfig(body);
        props.generate();
    }

    return (
        <>
            <div className="page-mask" onClick={props.close}/>
            <div className="report-configure-page comparison">
                <div className="report-configure-header">
                    <div className="report-configure-title col">Report Configurator</div>
                </div>
                <div className="report-configure-description-container">
                    <div className="report-configure-description">
                        This configuration tool enables you to include or exclude components rendered into the PDF for
                        you to share with your clients and their teams.
                    </div>
                    <div className="report-configure-description">
                        You report will be generated server side and available in the Reports page for you to open
                        or download.
                    </div>
                </div>
                <div className="field-input">
                    <div className="label">Report Name</div>
                    <div className="field-input-entry">
                        <input className="report-input" name="report-name" type="text" value={reportName}
                               onChange={ev => setReportName(ev.target.value)} required
                        />
                    </div>
                </div>
                <div className="report-configure-options-container">
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Report Title Page</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={coverPages ? "slider-container on" : "slider-container off"}
                                     id="1" onClick={handleSlider}>
                                    <div className={coverPages ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Introduction to PERILL</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={introduction ? "slider-container on" : "slider-container off"}
                                     id="2" onClick={handleSlider}>
                                    <div className={introduction ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Interpreting & Debriefing Guidance</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={debrief ? "slider-container on" : "slider-container off"}
                                     id="3" onClick={handleSlider}>
                                    <div className={debrief ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Survey Overview Card</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={detailCards ? "slider-container on" : "slider-container off"}
                                     id="4" onClick={handleSlider}>
                                    <div className={detailCards ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">PERILL Results Wheel: Survey Point Comparison</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={graphicalCharts ? "slider-container on" : "slider-container off"}
                                     id="5" onClick={handleSlider}>
                                    <div className={graphicalCharts ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="report-configure-options-row">
                        <div className="report-configure-option-title">Score Overview: Survey Point Comparison</div>
                        <div className="report-configure-option-slider-container">
                            <div className="slider">
                                <div className={dataTables ? "slider-container on" : "slider-container off"}
                                     id="6" onClick={handleSlider}>
                                    <div className={dataTables ? "slider-button on" : "slider-button off"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="report-configure-submit-container">
                    <div className={`report-configure-submit link ${reportName ? "active" : "disabled"}`}
                         onClick={reportName ? handleSubmit : null}>Generate Report</div>
                </div>
            </div>
        </>
    )
}

export default ComparisonReportConfigurator
